import { useTrainingStore } from '~/training/state';
import { isForceDarkTheme, isForceLightTheme } from '~/lib/themes/forceTheme';

const useIsDarkMode = () => {
  const darkMode = useTrainingStore(s => s.darkMode);

  if (isForceDarkTheme()) return true;
  if (isForceLightTheme()) return false;

  // Course builder has no learner theme yet — match App.tsx (always MainStyle).
  const path = window?.location?.pathname;
  if (path === '/editor' || path === '/preview') return false;

  if (!darkMode) return false;
  if (darkMode === 'dark') return true;
  if (darkMode === 'automatic')
    return (
      window?.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false
    );

  return false;
};

export default useIsDarkMode;
